import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["emptyButton", "selectedButton", "item"];
  static classes = ["hidden"];

  declare readonly emptyButtonTarget: HTMLElement;
  declare readonly selectedButtonTarget: HTMLElement;
  declare readonly itemTargets: HTMLInputElement[];
  declare readonly hiddenClass: string;

  connect() {
    this.updateButtonVisibility();
  }

  toggle() {
    this.updateButtonVisibility();
  }

  private updateButtonVisibility() {
    const hasSelections = this.areAnyItemsSelected();

    this.emptyButtonTarget.classList.toggle(this.hiddenClass, hasSelections);
    this.selectedButtonTarget.classList.toggle(
      this.hiddenClass,
      !hasSelections
    );
  }

  private areAnyItemsSelected(): boolean {
    return this.itemTargets.some((item) => item.checked);
  }
}
